var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PrimaryButton',{staticClass:"o-primary-btn--option l-options-grid__button",on:{"click":_vm.emitClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }